<template>
<div>
  <div class="card-body">
    <h5 class="card-title">{{ title }} <small class="text-muted" v-show="subTitle">{{ subTitle }}</small></h5>
    <ul>
      <li v-for="wo in orders" class="mt-1">
        <router-link :to="{ name: 'InternalOrder', params: { workOrderId: wo.id } }" target="_blank">
        {{ wo.orderNumber }}
        </router-link> <OrderBadge :workOrder="wo" /> {{ wo.subject }}
      </li>
    </ul>
    <p v-show="orders.length === 0">Ni nalogov.</p>
    <p v-show="paging.itemsPerPage === orders.length">
      Obstaja več nalogov, vendar nimamo implementiranega prikaza.
    </p>
  </div>
</div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { EMPTY_GUID } from "../utils/constants"
import { useWorkOrders } from "../composition-api/useWorkOrders"

defineOptions({ name: "InternalOrdersCard" })

const props = defineProps({
    statuses: {
      type: String,
      default: "",
    },
    ownerID: {
      type: String,
      default: EMPTY_GUID,
    },
    internalOrderTypes: {
      type: String,
      default: "",
    },
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    itemsPerPage: {
      type: Number,
      default: 25,
    },
  })

const { filters, orders, paging } = useWorkOrders("Internal")

watch(
  () => [props.statuses, props.ownerID, props.internalOrderTypes, props.itemsPerPage],
  ([statuses, ownerID, internalOrderTypes, itemsPerPage]) => {
    filters.status = statuses
    filters.ownerID = ownerID
    filters.internalOrderTypes = internalOrderTypes
    paging.value.itemsPerPage = itemsPerPage
  },
  { immediate: true },
)
</script>
